import { Component, OnInit } from '@angular/core';

import { Orgao } from "../shared/orgao.model";
import { orgaosModuleName } from "../shared/data.service";
import { OrgaoApiService } from "../shared/orgao-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { OrgaoNavigationService } from "../shared/orgao-navigation.service";
import { EnderecoService } from "../../enderecos/shared/endereco.service";
import { Area } from "../../areas/shared/area.model";
import {OrgaoService} from "../shared/orgao.service";

@Component({
  template: require('./orgao-list.component.html'),
  styles: [require('./orgao-list.component.css')]
})
export class OrgaoListComponent implements OnInit {
  list: Orgao[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  orgaosModuleName: any = orgaosModuleName;

  constructor(
    private _orgaosApiService: OrgaoApiService,
    private _orgaoNavigationService: OrgaoNavigationService,
    private _orgaoService: OrgaoService,
    private _utilService: UtilService,
    private _enderecoService: EnderecoService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._orgaoService.clearSessionStorage();
    this._orgaoNavigationService.goToNew();
  }

  clickEdit(item: Orgao) {
    this._orgaoService.clearSessionStorage();
    this._orgaoNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Orgao) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: any, lenX: any;
        for (x = 0, lenX = Response.length; x < lenX; x++) {
          if (Response[x].endereco) {
            Response[x].address = this._enderecoService.getAddress(Response[x].endereco);
          }
        }

        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._orgaosApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._orgaosApiService.onDelete(item.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-list/orgao-list.component.ts
 **/